import GroupsCard from "./GroupsCard"

export default  GroupsCard;



// WEBPACK FOOTER //
// ./src/components/App/DriversManagerDashboard/SelectableDrivers/Groups/GroupsCard/index.js